import * as React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";
import { getRentDueReport } from "state/apis";
import "./index.css";
import { Grid } from "@mui/material";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import GetAppIcon from "@mui/icons-material/GetApp";
import Button from "@mui/material/Button";
import { formatAmount } from "utils/constants";

const RentedDueDates = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [propertyId, setPropertyId] = React.useState(property);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        }
        fetchData(propertyId);
        setIsLoading(false);
    }, []);

    const fetchData = async (id) => {
        try {
            const res = await getRentDueReport(id);
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };
    const handleAllProperty = (e) => {
        let value = e.target.checked;
        if (value) {
            setPropertyId("");
            fetchData("");
        } else {
            fetchData(property);
            setPropertyId(property);
        }
    };

    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item xs={4}>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.vacant}
                                        onChange={(e) => handleAllProperty(e)}
                                        name="vacant"
                                        color="primary"
                                    />
                                }
                                label="All properties"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <Button
                            href={`${process.env.REACT_APP_BASE_URL}contract-registration/download-xlsx/${property}`}
                            target="_blank"
                            variant="contained"
                            className="download-btn"
                            sx={{
                                marginRight: "auto",
                                backgroundColor: "green",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "darkgreen",
                                },
                            }}
                        >
                            XLSX <GetAppIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            <div className="report-container">
                <table border="1" cellPadding="5" cellSpacing="0">
                    <thead>
                        <tr>
                            <th colSpan={11} style={{ textAlign: "center" }}>
                                {propertyName}
                            </th>
                        </tr>

                        <tr>
                            <th style={{ textAlign: "center" }}>SR NO</th>
                            <th style={{ textAlign: "center" }}>PROPERTY NAME</th>
                            <th style={{ textAlign: "center" }}>UNIT</th>
                            <th style={{ textAlign: "center" }}>TENANT NAME</th>
                            <th style={{ textAlign: "center" }}>TENANT CONTACT</th>
                            <th style={{ textAlign: "center" }}>CONTRACT FROM</th>
                            <th style={{ textAlign: "center" }}>CONTRACT TO</th>
                            <th style={{ textAlign: "center" }}>RENT PAID UPTO</th>
                            <th style={{ textAlign: "center" }}>RENTED DAYS</th>
                            <th style={{ textAlign: "center" }}>BALANCE</th>
                            <th style={{ textAlign: "center" }}>EXTRA / DUE AMT</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data && data.length ? (
                            <>
                                {data.map((val, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{val.propertyName}</td>
                                        <td>{val.unitNumber}</td>
                                        <td>{val.name}</td>
                                        <td>{val.contact1 !== null ? val.contact1 : "-"}</td>
                                        <td>
                                            {val.contractFrom
                                                ? moment(val.contractFrom).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td>
                                            {val.contractTo
                                                ? moment(val.contractTo).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td>
                                            {val.rentPaidUpToDate
                                                ? moment(val.rentPaidUpToDate).format("DD/MM/YYYY")
                                                : ""}
                                        </td>
                                        <td>{val.dayDiff}</td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(val.balance))}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {formatAmount(Number(val.dueAmount))}
                                        </td>
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr>
                                <td colSpan="11" style={{ textAlign: "center" }}>
                                    No data found
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td colSpan={11}></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Box>
    );
};

export default RentedDueDates;
